import type { CloudflareAsset } from "@/shared/common/enums";
import { CloudFlareImage } from "@/shared/components";
import { components } from "@ab.uitools/ui-library/components/ReactSelect";
import type {
  SingleValueProps,
  TOption
} from "@ab.uitools/ui-library/components/ReactSelect/types";
import { Text } from "@ab.uitools/ui-library/components/Text";

export const CurrencySelectSingleValue = (props: SingleValueProps<TOption>) => (
  <components.SingleValue {...props}>
    <div className="flexbox align-items--center">
      <CloudFlareImage className="flag-icon" path={props.data.icon as CloudflareAsset}/>
      <Text className="pl-6">{props.data.label}</Text>
    </div>
  </components.SingleValue>
);
